import { Subject } from 'rxjs';
import { superagent } from '../../shared/superagent/superagent';
import singletons from '../../shared/singletons'


class CartData {
  constructor() {
    this.data = {}
    this.orderMade = false
    this.subject = new Subject()
  }

  initFromData() {
    try {
      this.data = JSON.parse(document.body.getAttribute('data-cart-params'))
      console.log(this.data)
    } catch(e) {
      console.log('error cart-params')
    }
  }

  updateItem(item, q = 1) {
    // singletons['loading'].start()
    const payload = {item_id: item.itemId, quantity: q}
    if(item.priceGroupId) payload.price_group_id = item.priceGroupId
    superagent
      .put('/api/cart/update')
      .send(payload)
      .end((err, res)=> {
        this.data = res.body.data
        this.subject.next(this.data)
        // singletons['loading'].stop()
      })
  }



  clear(h={}) {

    this.data.items.map((x)=> ['#item_thumb_',x['item_id']].join('') ).forEach((it)=> {
      $(it).remove()
    })

    singletons['loading'].start()
    superagent
      .delete('/api/cart/clean')
      .send({})
      .end((err, res)=> {
        this.data = res.body.data
        if(h['orderMade']) {
          this.orderMade = true
        }
        this.subject.next(this.data)

        singletons['loading'].stop()
      })
  }

  inCart(item_id) {

    let it = this.data.items.find((it)=> {
      return it.item_id == item_id
    })
    if(it)
      return it.quantity
    return 0
  }

  cartTotalItems() {
    return this.data.items.reduce((s, i)=> {
      return s += i.quantity
    }, 0)
  }

  sum() {
    return this.data.items.reduce((s, i)=> {
      return s += i.quantity * i.price
    }, 0)
  }
}

let cd = new CartData()


export default cd;



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/react/cart/models/cart.js